import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output, SimpleChanges
} from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { PreviewEditTemplateSelectors } from '../../preview-edit-template/state/preview-edit-template.selectors';
import { Subscription } from 'rxjs';
import { soundSoundIdURL, soundTTSUrl } from './powernova-value.model';

@Component({
    selector: 'powernovavalue',
    templateUrl: './powernova-value.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class PowernovaValueComponent implements OnInit, OnChanges {

    @Input() type;
    @Input() voiceMessage;
    @Input() isOnlyPreview;
    @Input() uiText;
    @Input() soundId;
    @Input() contextVariables;
    @Input() model;
    @Input() audioService: string;
    @Input() playSequence;
    @Input() sequenceNumber;
    @Input() soundName;
    @Input() isAppointment;
    @Input() src;
    @Output() readonly isEnded: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() readonly selectedNodeChange: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    selectedNode: any;
    userAgent = '';
    playerStatus$: Observable<string>;
    percentElapsed$: Observable<string>;
    isLoadingNewTTSAudio$: Observable<boolean>;
    isLoading = false;
    ttsMessage: '';

    private _subscription: Subscription = new Subscription();

    constructor(private previewEditTemplateSelector: PreviewEditTemplateSelectors) {
        this.isLoadingNewTTSAudio$ = previewEditTemplateSelector.selectIsModelProcessed();
    }

    setSelectedNode(event): void {
        this.selectedNode = event.currentTarget;
        this.selectedNodeChange.emit(this.selectedNode);
    }

    ngOnInit(): void {
        // NOTE: In safari, the audio duration is always coming as INFINITY (Known bug),
        // so we will not display the headPOS in that case.
        this.userAgent = window.navigator.userAgent;

        if (Boolean(this.model)) {
          const templateVariable = this.getVariableWithoutPrefix(this.model);
          this._subscription.add(
            this.previewEditTemplateSelector.selectGetContextVariable()
              .subscribe((contextVariable) => {
                  this.ttsMessage = contextVariable[`${templateVariable}`];
                  this.src = templateVariable.indexOf('Sound') !== -1
                      ? `${soundSoundIdURL}${this.ttsMessage}`  // JACOB: This is confusing - using ttsMessage when it should be soundId
                      : `${soundTTSUrl}${this.ttsMessage}`;
              }
            )
          );

          this._subscription.add(
            this.previewEditTemplateSelector.selectIsModelProcessed()
              .subscribe((isProcessed) => {
                this.isLoading = !isProcessed;
              })
          );
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
    }


    private getVariableWithoutPrefix(variable: string): string {
      return variable.split('.')[1];
    }
}
